var map = {
	"./E.png": 2874,
	"./ENE.png": 1249,
	"./ESE.png": 5262,
	"./N.png": 8777,
	"./NE.png": 5872,
	"./NNE.png": 2678,
	"./NNW.png": 8132,
	"./NW.png": 8770,
	"./S.png": 4908,
	"./SE.png": 5115,
	"./SSE.png": 500,
	"./SSW.png": 2710,
	"./SW.png": 9721,
	"./W.png": 9800,
	"./WNW.png": 3809,
	"./WSW.png": 6986,
	"./北.png": 7000,
	"./北北東.png": 1912,
	"./北北西.png": 4678,
	"./南.png": 8024,
	"./南南東.png": 8648,
	"./南南西.png": 4934,
	"./東.png": 8030,
	"./東北.png": 7907,
	"./東北東.png": 6498,
	"./東南.png": 4355,
	"./東南東.png": 8882,
	"./西.png": 5984,
	"./西北.png": 8637,
	"./西北西.png": 6910,
	"./西南.png": 618,
	"./西南西.png": 4990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3028;